import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as pbi from 'powerbi-client'
import { PowerbiReportViewerService } from './powerbi-report-viewer.service';
import { ActivatedRoute } from '@angular/router';
import { AppConfigurationService } from '../../../core/services/AppConfigurationService';

@Component({
  selector: 'brd-powerbi-report-viewer',
  templateUrl: './powerbi-report-viewer.component.html',
  styleUrls: ['./powerbi-report-viewer.component.scss'],
  providers: [PowerbiReportViewerService]
})
export class PowerbiReportViewerComponent implements OnInit {
  report: pbi.Embed;
  reportId: string;
  workspaceId: string;
  reportPathName: string;
  jobKey: string;
  isPortal: Boolean;
  @ViewChild('reportContainer') reportContainer: ElementRef;

  constructor(
    public _powerbiService: PowerbiReportViewerService,
    private route: ActivatedRoute,
    private appConfigurationService: AppConfigurationService
  ) {
    this.workspaceId = appConfigurationService.configuration.workspaceId;
    this.reportPathName = appConfigurationService.configuration.reportPath;
  }

  ngOnInit() {
    this.route.params.subscribe(p => {
      this.jobKey = p['key'];
      this.isPortal = p['isPortal'];
    })

    this._powerbiService.getEmbedInfoByPathName(this.workspaceId, this.reportPathName)
      .subscribe((response: any) => {
        this.showReport(response.model);
      })
  }

  showReport(model) {
    let embedUrl = model.embedReport.embedUrl;
    console.log("embedUrl : " + embedUrl);
    embedUrl = embedUrl + `&rp:JobKey=${this.jobKey}`;
    let embedReportId = model.embedReport.reportId;
    let accessToken = model.embedToken.token;
    let settings: pbi.IEmbedSettings = {
      filterPaneEnabled: true,
      navContentPaneEnabled: true,
      bars: {
        actionBar: {
          visible: true,
        }
      }
    };
    let config: pbi.IEmbedConfiguration = {
      type: model.type,
      tokenType: pbi.models.TokenType.Embed,
      accessToken: accessToken,
      embedUrl: embedUrl,
      id: embedReportId,
      filters: [],
      settings: settings
    };
    let reportContainer = this.reportContainer.nativeElement;
    let powerbi = new pbi.service.Service(
      pbi.factories.hpmFactory,
      pbi.factories.wpmpFactory,
      pbi.factories.routerFactory,
    );
    this.report = powerbi.embed(reportContainer, config);
    this.report.off('loaded');
    this.report.on('loaded', () => { });
    this.report.on('error', () => {
      console.log('Error');
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/submission/components/powerbi-report-viewer/powerbi-report-viewer.component.ts